export const purple = '#64309A';
export const green = '#08B4A4';
export const yellow = '#F9A825';
export const red = '#F44336';

export const statusColors = { purple, green, yellow, red };
